import { PREFERRED_CAREER_COUNTRIES } from '../../shared/config/constants';

export const mapCountryCode = (countryCode) => {
    const code = countryCode.toLowerCase();

    const { name } = PREFERRED_CAREER_COUNTRIES.find(country => country.code === code) || {};

    return {
        code,
        name,
    };
};
